import React from "react";
import { useLocation } from "react-router";
import { Collapse } from "react-bootstrap";
import { SidebarDownIcon, SidebarUpIcon } from "../../assets";
import { EMPTY_STRING, navItems } from "../../constants";
import CustomSvg from "../../shared/components/custom-svg/CustomSvg";

const AdminSidebar = ({ className = EMPTY_STRING, navigateToPath }) => {
  const { pathname } = useLocation();

  const isActive = (path, matcher) =>
    pathname.includes(path) || (matcher && pathname.includes(matcher));

  return (
    <div className={`mt-5 pt-5 admin-sidebar ${className}`}>
      <div className="sidebar-content">
        {navItems.map((navItem, index) => {
          const hasChildren = !!navItem.children;
          const active = isActive(navItem.path, navItem.matcher);

          return (
            <div key={index}>
              <div
                className={`nav-item ${
                  active ? "selected-nav-item" : EMPTY_STRING
                } ${hasChildren ? "item-with-children" : EMPTY_STRING}`}
                onClick={() =>
                  navigateToPath(navItem.path || navItem.children[0].path)
                }
              >
                <CustomSvg src={navItem.icon} />
                <div>{navItem.title}</div>
                {hasChildren && (
                  <img
                    className="parent-icon"
                    src={active ? SidebarUpIcon : SidebarDownIcon}
                    alt={active ? "Collapse" : "Expand"}
                  />
                )}
              </div>
              {hasChildren && (
                <Collapse in={active}>
                  <div className="children-container">
                    {navItem.children.map((child, childIndex) => (
                      <div
                        key={childIndex}
                        className={`nav-item sub-nav-item ${
                          pathname.includes(child.path)
                            ? "selected-nav-item"
                            : EMPTY_STRING
                        }`}
                        onClick={() => navigateToPath(child.path)}
                      >
                        <div>{child.title}</div>
                      </div>
                    ))}
                  </div>
                </Collapse>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminSidebar;
